export default "__VITE_ASSET__JUKLTF5I__"